import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './WageCreateScreen';
import WageCreate from './WageCreateScreen';
import { StoreState } from 'src/store/reducers';
import { getProvidersSmall } from '../../../../../../store/actions/provider-actions';
import { selectNameProviders } from '../../../../../../store/selectors/providers-selectors';
import { formValueSelector } from 'redux-form';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    const selector = formValueSelector('wage-form');
    const providerDropdown = selector(state, 'providerDropDown');
    return {
        providers: selectNameProviders(state),
        providerSelect: providerDropdown?.value,
        inProgress: state.wages.inProgress,
        inProgressProvider: state.providers.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getProviders: (params) => dispatch(getProvidersSmall(params)),
    };
}

const WageCreateScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(WageCreate);

export default WageCreateScreen;
